/* PureEthical - pe-swatch.js
   As bolinhas de cor no cartao do produto (grelhas e filas).

   DUAS COISAS:
   1. pintar  - o mapa de cores do product-card.liquid tem 29 entradas
                quase todas em ingles. As fichas agrupadas trazem os
                nomes em portugues (Preto, Taupe, Bege, Marinho) e as
                antigas em italiano ou frances, porque o catalogo vem
                do fornecedor. Uma cor nao reconhecida ficava
                cinzenta. Este mapa cobre PT/EN/IT/FR.
   2. trocar  - passar o rato (ou tocar) numa bolinha mostra a foto
                dessa cor no proprio cartao, sem sair da grelha. E' o
                que substitui as miniaturas que estavam por baixo.

   A foto vem em data-img a 160px (e' o que o liquid pede, para as
   miniaturas). Num cartao de 540px ficaria desfocada, por isso
   reescreve-se o parametro width do URL do CDN.

   DETALHE: o cartao tem uma segunda foto (.pc-img-alt) que aparece em
   hover por cima da primeira. Enquanto uma cor esta' escolhida essa
   segunda foto tem de desaparecer, senao mostra a cor errada.

   SEM EXPRESSOES REGULARES de proposito: este ficheiro e' escrito e
   reescrito por ferramentas que passam por JSON, onde cada barra
   invertida e' uma oportunidade de corromper o ficheiro em silencio.
*/
(function () {
  'use strict';

  var MAP = {
    'preto': '#111111', 'black': '#111111', 'nero': '#111111', 'noir': '#111111',
    'branco': '#F7F7F5', 'white': '#F7F7F5', 'bianco': '#F7F7F5', 'blanc': '#F7F7F5',
    'optical white': '#FFFFFF', 'off white': '#F1EDE4', 'cru': '#F0E9DC', 'ecru': '#F0E9DC',
    'cinza': '#9E9E9E', 'cinzento': '#9E9E9E', 'grey': '#9E9E9E', 'gray': '#9E9E9E',
    'grigio': '#9E9E9E', 'gris': '#9E9E9E', 'antracite': '#3A3D40', 'anthracite': '#3A3D40',
    'chumbo': '#5A5E62', 'charcoal': '#36454F', 'prata': '#C9C9C9', 'silver': '#C9C9C9',
    'argento': '#C9C9C9',
    'azul': '#2E64C8', 'blue': '#2E64C8', 'blu': '#2E64C8', 'bleu': '#2E64C8',
    'marinho': '#1B2A4A', 'navy': '#1B2A4A', 'azul marinho': '#1B2A4A',
    'blu navy': '#1B2A4A', 'azul escuro': '#1B2A4A',
    'celeste': '#7FB6E0', 'azzurro': '#7FB6E0', 'azul claro': '#7FB6E0',
    'light blue': '#7FB6E0', 'denim': '#3D5A80', 'indigo': '#2A3A5C',
    'turquesa': '#1EA39B', 'turquoise': '#1EA39B', 'petroleo': '#11525A', 'teal': '#00897B',
    'verde': '#2E7D32', 'green': '#2E7D32', 'vert': '#2E7D32',
    'verde militar': '#4A5233', 'militare': '#4A5233', 'military': '#4A5233',
    'kaki': '#79734F', 'khaki': '#79734F', 'caqui': '#79734F',
    'oliva': '#6D7C43', 'olive': '#6D7C43',
    'verde claro': '#7CB87F', 'menta': '#A5D6A7', 'mint': '#A5D6A7',
    'verde escuro': '#1E4620', 'bottiglia': '#1E4620', 'garrafa': '#1E4620',
    'vermelho': '#D32F2F', 'red': '#D32F2F', 'rosso': '#D32F2F', 'rouge': '#D32F2F',
    'bordeaux': '#5E1A24', 'bordo': '#5E1A24', 'burgundy': '#5E1A24', 'vinho': '#5E1A24',
    'rosa': '#EFA0B4', 'pink': '#EFA0B4', 'rose': '#EFA0B4',
    'rosa claro': '#F6C9D4', 'cipria': '#EDC7C2', 'blush': '#EDC7C2',
    'fuchsia': '#C2185B', 'fucsia': '#C2185B', 'magenta': '#C2185B',
    'coral': '#FF7043', 'salmao': '#F19C7E', 'salmone': '#F19C7E',
    'laranja': '#EF7A22', 'orange': '#EF7A22', 'arancio': '#EF7A22', 'arancione': '#EF7A22',
    'amarelo': '#EFC024', 'yellow': '#EFC024', 'giallo': '#EFC024', 'jaune': '#EFC024',
    'mostarda': '#C99A20', 'mustard': '#C99A20', 'ocra': '#C08A2E', 'ocre': '#C08A2E',
    'marrom': '#6B4A34', 'castanho': '#6B4A34', 'brown': '#6B4A34',
    'marrone': '#6B4A34', 'marron': '#6B4A34',
    'camel': '#B98A54', 'cammello': '#B98A54', 'caramelo': '#A66A32',
    'cognac': '#8B4A2B', 'conhaque': '#8B4A2B', 'couro': '#8B5A2B', 'cuoio': '#8B5A2B',
    'taupe': '#8B7F73', 'tortora': '#9A8F85',
    'bege': '#D9C7AE', 'beige': '#D9C7AE', 'sabbia': '#DCCBAE', 'areia': '#DCCBAE',
    'sand': '#DCCBAE', 'nude': '#E4C7A8', 'tan': '#C79A63',
    'creme': '#F3EADA', 'cream': '#F3EADA', 'panna': '#F3EADA',
    'chocolate': '#4A2C20', 'cioccolato': '#4A2C20', 'testa di moro': '#3E2B22',
    'roxo': '#6A3B8C', 'purple': '#6A3B8C', 'viola': '#6A3B8C', 'violet': '#6A3B8C',
    'lilas': '#B9A2D6', 'lilla': '#B9A2D6', 'lavanda': '#BCA6D4',
    'dourado': '#C4A24A', 'gold': '#C4A24A', 'oro': '#C4A24A', 'ouro': '#C4A24A',
    'bronze': '#9A7B4F', 'cobre': '#A5673F',
    'transparente': '#EDEDED', 'trasparente': '#EDEDED',
    /* nomes que aparecem no catalogo agrupado e faltavam */
    'ganga': '#3D5A80', 'jeans': '#3D5A80',
    'marfim': '#F3EEDF', 'ivory': '#F3EEDF', 'avorio': '#F3EEDF',
    'prateado': '#C9C9C9', 'branco sujo': '#F1EDE4',
    'antracite escuro': '#2E3134',
    /* v37 (4E.9): nomes alemaes. Em de.pureethical.com e em /de a Shopify entrega os valores das cores
       ja traduzidos (Schwarz, Hellblau, Gruen...) e sem estes nomes as bolinhas ficavam cinzentas.
       A norm() tira os acentos (gruen -> grun) e troca o hifen por espaco. */
    'schwarz': '#111111', 'weiß': '#F7F7F5', 'weiss': '#F7F7F5', 'altweiß': '#F1EDE4', 'altweiss': '#F1EDE4',
    'offweiß': '#F1EDE4', 'offweiss': '#F1EDE4', 'cremeweiß': '#F1EDE4', 'cremeweiss': '#F1EDE4',
    'grau': '#9E9E9E', 'anthrazit': '#3A3D40', 'silber': '#C9C9C9',
    'blau': '#2E64C8', 'hellblau': '#7FB6E0', 'marineblau': '#1B2A4A', 'dunkelblau': '#1B2A4A',
    'grun': '#2E7D32', 'militargrun': '#4A5233', 'armeegrun': '#4A5233', 'olivgrun': '#6D7C43',
    'rot': '#D32F2F', 'lila': '#6A3B8C', 'gelb': '#EFC024', 'braun': '#6B4A34',
    'elfenbein': '#F3EEDF', 'koralle': '#FF7043', 'mauve': '#B784A7',
    /* traducoes automaticas erradas ainda guardadas na Shopify (ver 4E.6): a bolinha mostra a cor certa
       enquanto os dados nao forem corrigidos. Podem sair depois da correcao das traducoes. */
    'ganges': '#3D5A80', 'bordure': '#5E1A24', 'grausam': '#F0E9DC', 'dorada': '#C4A24A',
    'kamel': '#B98A54', 'malve': '#B784A7'
  };

  /* padroes: nenhuma cor unica os representa honestamente, por isso
     desenha-se um gradiente em vez de escolher uma cor ao calhas */
  var RAINBOW = 'conic-gradient(#D32F2F,#EFC024,#2E7D32,#2E64C8,#6A3B8C,#D32F2F)';
  var PAT = {
    'multicolor': RAINBOW, 'multicor': RAINBOW, 'fantasia': RAINBOW,
    'estampado': RAINBOW, 'print': RAINBOW, 'stampa': RAINBOW, 'gemustert': RAINBOW, 'druckmuster': RAINBOW,
    'camuflado': 'linear-gradient(135deg,#4A5233 0 40%,#79734F 40% 70%,#2F3524 70%)',
    'camouflage': 'linear-gradient(135deg,#4A5233 0 40%,#79734F 40% 70%,#2F3524 70%)',
    'riscas': 'repeating-linear-gradient(135deg,#1B2A4A 0 3px,#F7F7F5 3px 6px)',
    'righe': 'repeating-linear-gradient(135deg,#1B2A4A 0 3px,#F7F7F5 3px 6px)',
    'stripe': 'repeating-linear-gradient(135deg,#1B2A4A 0 3px,#F7F7F5 3px 6px)',
    'xadrez': 'repeating-linear-gradient(90deg,#6B4A34 0 3px,#D9C7AE 3px 6px)',
    'quadri': 'repeating-linear-gradient(90deg,#6B4A34 0 3px,#D9C7AE 3px 6px)',
    'animalier': 'radial-gradient(circle at 30% 30%,#4A2C20 0 22%,transparent 22%),radial-gradient(circle at 70% 65%,#4A2C20 0 22%,transparent 22%),#C79A63',
    'leopardo': 'radial-gradient(circle at 30% 30%,#4A2C20 0 22%,transparent 22%),radial-gradient(circle at 70% 65%,#4A2C20 0 22%,transparent 22%),#C79A63'
  };

  var ACC = 'áàâãäéèêëíìîïóòôõöúùûüçñ';
  var PLAIN = 'aaaaaeeeeiiiiooooouuuucn';

  function norm(s) {
    /* o catalogo escreve "Azul-marinho" e "Verde-militar" com hifen;
       o mapa esta' escrito com espacos. Um hifen passa a espaco. */
    var v = String(s == null ? '' : s).toLowerCase().split('-').join(' ');
    var out = '';
    for (var i = 0; i < v.length; i++) {
      var ch = v.charAt(i);
      var j = ACC.indexOf(ch);
      out += j >= 0 ? PLAIN.charAt(j) : ch;
    }
    while (out.indexOf('  ') >= 0) out = out.split('  ').join(' ');
    return out.trim();
  }

  function duo(a, b) {
    return 'linear-gradient(90deg,' + a + ' 0 50%,' + b + ' 50% 100%)';
  }

  /* devolve {c: cor de fundo, img: background-image ou ''} */
  function paint(raw) {
    var v = norm(raw);
    if (!v) return { c: '#CFCFCF', img: '' };
    if (PAT[v]) return { c: '#CFCFCF', img: PAT[v] };
    if (MAP[v]) return { c: MAP[v], img: '' };

    /* bicolores: "Azul/Branco", "Azul|Branco", "Preto e Branco".
       O catalogo agrupado usa " e " - sao 40 e tantas fichas. */
    var bits = v.split('/').join('|').split(' e ').join('|').split(' und ').join('|').split('|');
    if (bits.length > 1) {
      var a = MAP[bits[0].trim()], b = MAP[bits[1].trim()];
      if (a && b) return { c: a, img: duo(a, b) };
      if (a) return { c: a, img: '' };
    }

    /* correspondencia parcial, preferindo a chave mais longa, para
       "azul marinho" nao cair em "azul" */
    var best = '', hit = null, k;
    for (k in PAT) {
      if (v.indexOf(k) >= 0 && k.length > best.length) { best = k; hit = { c: '#CFCFCF', img: PAT[k] }; }
    }
    for (k in MAP) {
      if (v.indexOf(k) >= 0 && k.length > best.length) { best = k; hit = { c: MAP[k], img: '' }; }
    }
    if (hit) return hit;
    return { c: '#CFCFCF', img: '' };
  }

  /* ---------- pintar ---------- */
  /* v35: no mesmo cartao, cores com o mesmo nome base ("Azul", "Azul 2") ficavam com bolinhas iguais.
     Nesses casos a bolinha mostra a foto da variante (data-img), para o cliente as distinguir. */
  function base(raw) {
    var w = norm(raw).split(' ');
    var n = w[w.length - 1];
    if (w.length > 1 && String(parseInt(n, 10)) === n) w.pop();
    return w.join(' ');
  }
  /* cor dominante do artigo numa foto de produto: o fundo e' a media dos
     cantos; fica-se com os pixeis que se afastam dele e tira-se a mediana
     de cada canal (a mediana ignora o logotipo e as costuras). */
  var SC = {};
  function sample(src, cb) {
    if (!src) return cb(null);
    if (SC.hasOwnProperty(src)) return cb(SC[src]);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var col = null;
      try {
        var W = 40, H = 50, cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var cs = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4], br = 0, bgc = 0, bb = 0;
        cs.forEach(function (i) { br += d[i]; bgc += d[i + 1]; bb += d[i + 2]; });
        br /= 4; bgc /= 4; bb /= 4;
        var thr = [45, 20], R, G, B;
        for (var k = 0; k < thr.length; k++) {
          R = []; G = []; B = [];
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 128) continue;
            if (Math.abs(d[i] - br) + Math.abs(d[i + 1] - bgc) + Math.abs(d[i + 2] - bb) > thr[k]) { R.push(d[i]); G.push(d[i + 1]); B.push(d[i + 2]); }
          }
          if (R.length > 80) break;
        }
        if (R.length > 30) {
          var med = function (a) { a.sort(function (m, n) { return m - n; }); return a[a.length >> 1]; };
          var r = med(R), g = med(G), bl = med(B);
          /* artigos claros: os pixeis "fora do fundo" sao sombras e solas,
             que puxam a cor para bege; aclara-se para ficar perto do branco */
          if (r > 160 && g > 160 && bl > 160) { r = Math.round(r + (255 - r) * .55); g = Math.round(g + (255 - g) * .55); bl = Math.round(bl + (255 - bl) * .55); }
          col = 'rgb(' + r + ',' + g + ',' + bl + ')';
        }
      } catch (e) { col = null; }
      SC[src] = col; cb(col);
    };
    im.onerror = function () { SC[src] = null; cb(null); };
    im.src = /width=\d+/.test(src) ? src.replace(/width=\d+/, 'width=80') : src;
  }
  function dots(root) {
    var list = (root || document).querySelectorAll('.pc-vthumb');
    Array.prototype.forEach.call(list, function (b) {
      if (b.getAttribute('data-pe-sw') === '1') return;
      var name = b.getAttribute('data-color') || b.getAttribute('aria-label') || '';
      var p = paint(name);
      var c = card(b);
      if (c && b.getAttribute('data-img')) {
        var same = 0, me = base(name);
        Array.prototype.forEach.call(c.querySelectorAll('.pc-vthumb'), function (o) {
          if (base(o.getAttribute('data-color') || '') === me) same++;
        });
        if (same > 1) {
          /* v35b: a foto recortada numa bolinha ora mostrava o logotipo ora o
             tecido. Agora tira-se a cor dominante do artigo na propria foto e
             pinta-se a bolinha lisa, como as outras. Se o browser nao deixar
             ler a imagem, fica a cor da paleta. */
          (function (el, src) {
            sample(src, function (col) {
              if (!col) return;
              try {
                el.style.setProperty('--pe-sw', col);
                el.style.setProperty('background-color', col, 'important');
                el.style.setProperty('background-image', 'none', 'important');
              } catch (e) {}
            });
          })(b, b.getAttribute('data-img'));
        }
      }
      try {
        b.style.setProperty('--pe-sw', p.c);
        b.style.setProperty('--pe-sw-img', p.img || 'none');
        /* segunda defesa: o liquid escreve background em style= sem
           !important; sem isto esse valor podia ganhar ao var() */
        b.style.setProperty('background-color', p.c, 'important');
        b.style.setProperty('background-image', p.img || 'none', 'important');
      } catch (e) {}
      b.setAttribute('data-pe-sw', '1');
      if (!b.getAttribute('title') && name) b.setAttribute('title', name);
    });
  }

  /* ---------- trocar a foto ---------- */
  /* o CDN da Shopify aceita width como parametro; o liquid pede 160 */
  function big(url) {
    if (!url) return '';
    var i = url.indexOf('width=');
    if (i < 0) return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=540';
    var start = i + 6, end = start;
    while (end < url.length && url.charAt(end) >= '0' && url.charAt(end) <= '9') end++;
    if (end === start) return url;
    return url.slice(0, start) + '540' + url.slice(end);
  }

  function card(el) { return el && el.closest ? el.closest('.product-card') : null; }

  function show(btn) {
    var c = card(btn);
    if (!c) return;
    var main = c.querySelector('.pc-img-main');
    var url = btn.getAttribute('data-img');
    if (!main || !url) return;
    if (!main.getAttribute('data-pe-orig')) {
      main.setAttribute('data-pe-orig', main.getAttribute('src') || '');
      var ss = main.getAttribute('srcset');
      if (ss) main.setAttribute('data-pe-origset', ss);
    }
    main.removeAttribute('srcset');
    main.setAttribute('src', big(url));
    c.classList.add('pe-sw-on');
    var alt = c.querySelector('.pc-img-alt');
    if (alt) alt.style.setProperty('display', 'none', 'important');
    Array.prototype.forEach.call(c.querySelectorAll('.pc-vthumb'), function (b) {
      if (b === btn) b.classList.add('on'); else b.classList.remove('on');
    });
  }

  function restore(c) {
    if (!c) return;
    var main = c.querySelector('.pc-img-main');
    if (main && main.getAttribute('data-pe-orig')) {
      main.setAttribute('src', main.getAttribute('data-pe-orig'));
      var ss = main.getAttribute('data-pe-origset');
      if (ss) main.setAttribute('srcset', ss);
    }
    var alt = c.querySelector('.pc-img-alt');
    if (alt) alt.style.removeProperty('display');
    c.classList.remove('pe-sw-on');
    Array.prototype.forEach.call(c.querySelectorAll('.pc-vthumb'), function (b) {
      b.classList.remove('on');
    });
  }

  /* rato: mostra enquanto esta' por cima, volta ao sair do cartao.
     Delegado, porque as grelhas sao reconstruidas pelos filtros. */
  document.addEventListener('mouseover', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pc-vthumb') : null;
    if (b) show(b);
  }, true);

  document.addEventListener('mouseout', function (e) {
    var c = card(e.target);
    if (!c) return;
    var to = e.relatedTarget;
    if (to && c.contains(to)) return;
    restore(c);
  }, true);

  /* toque: a primeira toca escolhe a cor e nao segue o link; a
     segunda na mesma bolinha ja' abre a ficha do produto */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pc-vthumb') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.classList.contains('on')) {
      var c = card(b);
      var link = c ? c.querySelector('.pc-link') : null;
      if (link && link.href) { window.location.href = link.href; return; }
    }
    show(b);
  }, true);

  /* ---------- arranque ---------- */
  function run() { dots(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  /* as grelhas sao refeitas pelos filtros e pelo scroll infinito */
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { dots(document); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
